import { useContext, useState, memo, useEffect, useRef } from 'react';
import {
  BefGlobalContext,
  BefLanguageServiceContext,
  BefMessageServiceContext,
  BefMetaDataServiceProvider,
  BefPage,
  BefPageContainerService,
  BefPageContainerServiceContext,
  BefPageControllerContext,
  BefPageService,
  BefPageServiceContext,
  BefRpcContext,
} from '@beflam/bef-core';
import PageAichat from './PageAichat';
import { Page } from './Page';
import { BefPluginServiceProvider } from '../service/bef-plugin-service.provider';

function PageInner(props: { page: BefPage }) {
  const page = props.page;
  const isUrl = (page.state ?? '').toLowerCase().startsWith('http');

  const globalService = useContext(BefGlobalContext);
  const pageControllerService = useContext(BefPageControllerContext);
  const pageContainerService = useContext(BefPageContainerServiceContext);
  const languageService = useContext(BefLanguageServiceContext);
  const messageService = useContext(BefMessageServiceContext);
  const rpcService = useContext(BefRpcContext);
  const [pageService, setPageService] = useState(
    new BefPageService(
      globalService,
      pageContainerService,
      pageControllerService,
      languageService,
      messageService,
      rpcService,
    ),
  );

  return (
    <BefPageServiceContext.Provider value={pageService}>
      <BefMetaDataServiceProvider>
        <BefPluginServiceProvider>
          {isUrl ? (
            <iframe
              style={{ border: 'none' }}
              allowFullScreen
              allow="fullscreen"
              width="100%"
              height="100%"
              src={page.state}
            ></iframe>
          ) : (
            <>
              <Page
                key={page.innerID}
                page={page}
                onPageServiceChanged={(value: any) => {
                  setPageService(value);
                }}
              />
              {globalService.agent?.AIAgent && page.appID !== '' && (
                <PageAichat />
              )}
            </>
          )}
        </BefPluginServiceProvider>
      </BefMetaDataServiceProvider>
    </BefPageServiceContext.Provider>
  );
}

const MemoPage = memo(
  PageInner,
  (prevProps, nextProps) => prevProps.page === nextProps.page,
);

export function PageContainer(props: any) {
  const containerService: BefPageContainerService = useContext(
    BefPageContainerServiceContext,
  );
  containerService.conatiner = props.container;
  const [pageContainer, pageContainerSet] = useState<any[]>(
    props.container.pages.map((page: BefPage) => {
      return { isActive: true, page: page };
    }),
  );

  useEffect(() => {
    const pagesChangedSub = containerService.pagesChanged.subscribe(
      (result) => {
        pageContainerSet(
          result.map((page: BefPage) => {
            return { isActive: page.isActive, page: page };
          }),
        );
      },
    );
    return () => {
      pagesChangedSub.unsubscribe();
    };
  }, []);
  return (
    <div
      ref={(ref) => (containerService.pageContainerRef = ref)}
      style={{ width: '100%', height: '100%', overflow: 'hidden' }}
    >
      {pageContainer.map((pageItem: any, index) => {
        return (
          <div
            key={pageItem.page.innerID}
            style={{
              width: '100%',
              height: '100%',
              display: pageItem.isActive ? undefined : 'none',
            }}
          >
            <MemoPage page={pageItem.page}></MemoPage>
          </div>
        );
      })}
    </div>
  );
}
